import React from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import I18n from '../../../config/i18n';
import { getBookingCheckPath } from '../../../routes/config';
import formFieldsets from '../static/fieldsets-form';
import BookingFormLayout from './BookingFormLayout';

const shouldRender = (props) =>
  !!(
    props.onDropdownChange &&
    props.onTextChange &&
    props.onCheckboxChange &&
    props.onPaymentChange &&
    props.onValidate
  );

const hiddenValues = `accommodation_id booking_id amount arrival current_persons
  duration_of_stay max_persons`.split(/\W+/);

const BookingForm = (props) => {
  const { handleSubmit, control } = useForm();

  return !shouldRender(props) ? null : (
    <BookingFormLayout
      action={getBookingCheckPath()}
      title={I18n.t('booking.booking_headline', { object_name: props.display_title })}
      fieldsets={formFieldsets()}
      {...props}
      handleSubmit={handleSubmit}
      control={control}
    >
      {hiddenValues.map((name) => (
        <Controller
          key={name}
          name={name}
          control={control}
          defaultValue={props[name] || ''}
          render={({ field: { value } }) => <input type="hidden" id={name} value={value} />}
        />
      ))}
    </BookingFormLayout>
  );
};

const tosLinkProp = PropTypes.arrayOf(
  PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
  }),
);

BookingForm.propTypes = {
  display_title: PropTypes.string,
  /* eslint-disable react/no-unused-prop-types */
  accommodation_id: PropTypes.number,
  booking_id: PropTypes.number,
  amount: PropTypes.number,
  arrival: PropTypes.string,
  current_persons: PropTypes.number,
  duration_of_stay: PropTypes.number,
  max_persons: PropTypes.number,
  is_holiday_home: PropTypes.bool,
  comment: PropTypes.string,
  accommodation_slug: PropTypes.string,
  options: PropTypes.shape({
    insurance_countries: PropTypes.array,
    salutations: PropTypes.array,
    payment_methods: PropTypes.array,
  }),
  tos_link: PropTypes.shape({
    de: tosLinkProp,
    be: tosLinkProp,
    nl: tosLinkProp,
    fr: tosLinkProp,
    es: tosLinkProp,
    en: tosLinkProp,
    hh: tosLinkProp,
  }),
  onDropdownChange: PropTypes.func,
  onTextChange: PropTypes.func,
  onCheckboxChange: PropTypes.func,
  onPaymentChange: PropTypes.func,
  onValidate: PropTypes.func,
  /* eslint-enable react/no-unused-prop-types */
};

export default BookingForm;
